import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Share from './share'

class RiderSharing extends Component {
  render() {
    const { shares } = this.props

    return (
      <ul className="sharing">
        {
          shares.map((share, index) => (
            <Share key={index}
              share={share}
              removeRiderShare={this.props.removeRiderShare} />
          ))
        }
      </ul>
    )
  }
}

RiderSharing.propTypes = {
  shares: PropTypes.array,
  removeRiderShare: PropTypes.func
}

RiderSharing.defaultProps = {
  shares: [],
  removeRiderShare: function() {}
}

export default RiderSharing



// WEBPACK FOOTER //
// ./src/components/rider/rider-sharing/sharing.js